var magicStyles = [".panic-bar[data-v-741755e2]{display:contents}"];

export default magicStyles;
